// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import { AddPasswordView } from "./view";

import { requiresAuth } from "../../utils/auth";
import { rootRoute } from "../root/route";

// why: reading storage throws SecurityError rather than returning null when it is
// blocked (private mode, third-party-cookie blocking, sandboxed iframe).
// beforeLoad runs on every route resolution, so an unguarded read white-screens
// the onboarding route instead of falling through to requiresAuth().
function readLocalStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export const addPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  beforeLoad({ search }) {
    const localToken = readLocalStorage("token");
    if (!("code" in search && "email" in search && !localToken)) {
      requiresAuth();
    }
  },
  path: "onboarding",
  component: AddPasswordView,
});
